import { createVNode as a, mergeProps as n } from "vue";
import m from "../node_modules/@pf-ui/pf-icon-svg/es/asn/RarTwoTone.js";
import s from "../components/PfIcon.js";
const o = (r, e) => {
  const t = {
    ...r,
    ...e.attrs
  };
  return a(s, n(t, {
    icon: m
  }), null);
};
o.displayName = "RarTwoTone";
o.inheritAttrs = !1;
export {
  o as default
};
